import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    padding: 4em 0;

    .layout-container {
        &.size-large {
            position: relative;
            height: 2em;
            font-size: 1.8em;

            .change-mode {
                top: -1.4em;
                right: 0;
                height: 2em;
                width: 2em;
                border-radius: 10px;
                position: absolute;
                border: 1px solid white;
                z-index: 2;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                svg {
                    width: 0.8em;
                }

                &.dark-mode {
                    border-color: #7A297D;
                }
            }
        }
    }

    .article {
        .list-headline {
            font-size: 2em;
            font-weight: 500;
            margin-bottom: 1em;
        }

        .content {
            margin-top: 2.5em;

            .layout-html-styled-content {
                div {
                    h2 {
                        font-weight: 600;
                        font-family: inherit !important;

                        span {
                            font-family: inherit !important;
                        }
                    }

                    h3 {
                        font-size: 20px;
                        font-weight: 400;
                        font-family: inherit !important;
                        margin-bottom: 0.8em;
                        color: ${vars.colorFullDark} !important;

                        span {
                            font-family: inherit !important;
                        }
                    }

                    ul {
                        padding: 0;
                        font-family: inherit !important;

                        li {
                            padding: 0.4em;
                            color: #5c5f66 !important;
                            font-size: 16px;
                            font-family: inherit !important;
                            line-height: 1.7;

                            span {
                                font-family: inherit !important;
                            }
                        }
                    }

                    p {
                        margin-bottom: 1em;
                        font-weight: 400;
                        font-family: inherit !important;
                        color: ${vars.colorDark} !important;
                        text-align: left !important;

                        span {
                            color: #5c5f66 !important;
                            font-family: inherit !important;
                            line-height: 1.7 !important;
                        }

                        strong {
                            font-weight: 700;
                            color: #5c5f66;
                            font-family: inherit !important;
                        }

                        a {
                            color: ${vars.backgroundLabel};
                            font-family: inherit !important;

                            span {
                                font-family: inherit !important;
                                color: ${vars.backgroundLabel} !important;

                                strong {
                                    font-weight: 700;
                                    font-family: inherit !important;
                                    color: inherit;
                                }
                            }

                            &:hover {
                                span {
                                    color: ${vars.backgroundLabel} !important;
                                }
                            }
                        }
                    }

                    img {
                        margin: 3em auto;
                    }
                }
            }
        }
    }

    .article-container {
        background-color: ${vars.backgroundWhite};
        color: ${vars.colorDark};
        border-radius: 10px;
        overflow: hidden;
        padding: 4em 7em;
        transition: background-color 200ms ease, color 200ms ease;

        &.dark-mode {
            background-color: ${vars.backgroundLayoutOnGray};
            color: ${vars.colorTextWhite};

            .article {
                .article-content-list {
                    .section-articles-article-index {
                        .dot {
                            background-color: ${vars.colorTextWhite};
                        }
                    }
                }

                .content {
                    .layout-html-styled-content {
                        div {
                            h1,
                            h2,
                            h3,
                            h4,
                            h5,
                            h6,
                            p,
                            a,
                            ul,
                            ol,
                            li,
                            a {
                                color: ${vars.colorTextWhite} !important;

                                span {
                                    color: inherit !important;
                                }

                                strong, em, del, ins {
                                    color: ${vars.colorTextWhite} !important;
                                }
                            }

                            img {
                                margin: 3em auto;
                            }
                        }
                    }
                }
            }

            .main-article-data {
                &__article-information {
                    .date,
                    .category {
                        &:before {
                            background-color: ${vars.colorTextLight};
                        }
                    }

                    .category {
                        color: ${vars.colorTextLight}
                    }
                }
            }
        }

        .article-author {
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            padding-top: 2em;
            margin-top: 2em;
            display: flex;
            gap: 1em;

            &__avatar {
                max-height: 160px;
                max-width: 160px;
                border-radius: 6px;
                overflow: hidden;


                img {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                }
            }

            &__information {
                display: flex;
                flex-direction: column;

                &-section-title {
                    font-size: 0.8em;
                }

                &-name {
                    font-size: 1.3em;
                    font-weight: 600;
                }

                &-bio {
                    margin-top: 0.4em;
                }
            }
        }

        .main-article-data {
            &__title {
                font-size: 3.4em;
                margin-bottom: 0.5em;
            }

            &__article-information {
                display: flex;
                flex-wrap: wrap;
                font-size: 0.9em;
                margin-bottom: 1em;

                & > * {
                    font-weight: 600;
                }

                .date,
                .category {
                    position: relative;
                    margin-right: 5px;
                    padding-right: 5px;

                    &:before {
                        position: absolute;
                        content: '';
                        width: 2px;
                        border-radius: 2px;
                        height: 60%;
                        right: -1px;
                        top: 20%;
                        transition: background-color 200ms ease;
                        background-color: ${vars.backgroundDarkGray};
                    }
                }

                .category {
                    transition: color 200ms ease;
                    color: #400E4E;
                }
            }

            &__article-image {
                width: 100%;
                border-radius: 10px;
                margin-bottom: 2em;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                z-index: 1;
                min-height: 34em;

                img {
                    object-fit: contain;
                    max-height: 600px;
                    max-width: 100%;
                    z-index: 1;

                    &.background {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        transform: scale(1.2);
                        filter: blur(8px);
                        object-fit: cover;
                        z-index: -1;
                    }
                }
            }

            &__content {
                font-size: 1.2em;
                margin-bottom: 2em;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    @media all and (max-width: ${vars.tabletL}) {
        .article-container {
            padding: 2em;
        }
    }

    @media all and (max-width: ${vars.mobileM}) {
        .article-container {
            .article-author {
                &__avatar {
                    max-height: 100px;
                    max-width: 100px;
                }
            }
        }
    }
`;
